var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: { title: _vm.$t("details"), visible: _vm.dialogShow },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "popover",
              staticStyle: { "flex-direction": "column" }
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.tableData, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "admin_name",
                      label: _vm.$t("operator"),
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "send_time",
                      label: _vm.$t("operationTime"),
                      align: "center",
                      width: "180"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "content",
                      label: _vm.$t("emailContent"),
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "quality",
                      label: _vm.$t("attachment"),
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "#409EFF",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.viewArticles.init(
                                      row.reward
                                    )
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("view")) + " ")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                attrs: {
                  layout: "total,sizes, prev, pager, next",
                  "current-page": _vm.paramsData.page,
                  total: _vm.total
                },
                on: {
                  "current-change": _vm.getList,
                  "size-change": _vm.sizeChange
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("confirm")) + " ")]
              )
            ],
            1
          )
        ]
      ),
      _c("viewArticles", { ref: "viewArticles" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }